import React, { useState, useEffect } from "react";

import { Container } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as LogoSvg } from '../../../assets/images/logo.svg';

import './style.scss'; 

export default function Header () {
    const isMobile = window.screen.width < 768;
    const [isBurgerActive, setIsBurgerActive] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsBurgerActive(false);
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <Container fluid className={`header ${isMobile ? 'isMobile' : ''}  ${isBurgerActive ? 'hamburger-active' : ''}`}>
            <Container>
                <Link to="/"><LogoSvg className={`logo ${isBurgerActive ? 'hide': ''}`}/></Link>
                <nav className="header-navigation">
                    <ul>
                        <li>
                            <Link className={`nav-text ${location.pathname === "/" ? 'active' : ''}`} to="/">home</Link>
                        </li>
                        <li>
                            <Link className={`nav-text ${location.pathname === "/services" ? 'active' : ''}`} to="/services">services</Link>
                        </li>
                        <li>
                            <Link className={`nav-text ${location.pathname === "/about-us" ? 'active' : ''}`} to="/about-us">about us</Link>
                        </li>
                        <li>
                            <Link className={`nav-text ${location.pathname === "/contacts" ? 'active' : ''}`} to="/contacts">contact us</Link>
                        </li>
                    </ul>
                </nav>
                
                <div className="hamburger-container" onClick={() => setIsBurgerActive(!isBurgerActive)} >
                    <span className="top"></span>
                    <span className="middle"></span>
                    <span className="bottom"></span>
                </div>
            </Container>
        </Container>
    )
}
